import { ArrowUpRight, BadgeEuro, HeartHandshake, MapPinned, Quote } from "lucide-react";
import { Link } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";

export default function ExpertisePage() {
  return (
    <main data-testid="expertise-page">
      <section className="agency-story-hero container">
        <div className="agency-story-intro">
          <p className="eyebrow coral-text">Notre expertise</p>
          <h1>L’Isle-sur-la-Sorgue,<br /><span>on connaît par cœur.</span></h1>
          <p>La Venise Comtadine n’est pas une zone de chalandise : c’est chez nous. Ses quais, ses antiquaires, ses villages voisins — et les projets de vie qui s’y écrivent.</p>
        </div>
        <img
          src="https://customer-assets-agu9un31.emergentagent.net/job_estate-portal-143/artifacts/zh3bonim_amis%20qui%20se%20check%20la%20main.jpg"
          alt="Accompagnement Pimp My Place à L’Isle-sur-la-Sorgue"
          loading="eager"
          decoding="async"
          data-testid="expertise-hero-image"
        />
      </section>

      <section className="section container">
        <div className="section-heading compact-heading">
          <div>
            <p className="eyebrow">Ce qui nous distingue</p>
            <h2>Trois engagements,<br />zéro mauvaise surprise.</h2>
          </div>
          <p className="section-intro">Une agence née après le Covid d’un constat simple : l’immobilier mérite plus d’écoute, plus de clarté et moins de pourcentages.</p>
        </div>
        <div className="service-grid">
          <article data-testid="expertise-fees-card">
            <BadgeEuro size={27} />
            <h3>Honoraires fixes, annoncés d’emblée</h3>
            <p>Dès 4 900 €, connus au premier rendez-vous. Aucun pourcentage : votre prix de vente n’augmente jamais nos honoraires.</p>
            <Link to="/honoraires" data-testid="expertise-fees-link">Voir la grille <ArrowUpRight size={17} /></Link>
          </article>
          <article data-testid="expertise-local-card">
            <MapPinned size={27} />
            <h3>Une lecture hyper-locale du marché</h3>
            <p>L’Isle-sur-la-Sorgue et 82 communes dans un rayon de 30 km : Le Thor, Fontaine-de-Vaucluse, Saumane, Châteauneuf-de-Gadagne… Chaque adresse a son prix juste.</p>
            <Link to="/guides" data-testid="expertise-guides-link">Lire nos guides <ArrowUpRight size={17} /></Link>
          </article>
          <article data-testid="expertise-human-card">
            <HeartHandshake size={27} />
            <h3>L’humain avant le mandat</h3>
            <p>On commence par écouter, expliquer et conseiller — même si vous décidez finalement de vendre seul. La confiance d’abord, le mandat ensuite.</p>
            <Link to="/agence" data-testid="expertise-agency-link">Notre histoire <ArrowUpRight size={17} /></Link>
          </article>
        </div>
      </section>

      <section className="agency-story-band" data-testid="expertise-values-band">
        <div className="container">
          <p>Notre boussole tient en une phrase.</p>
          <h2>Gagner votre confiance<br /><span>avant de gagner votre mandat.</span></h2>
        </div>
      </section>

      <section className="agency-story-content container">
        <article>
          <p>Vendre à L’Isle-sur-la-Sorgue, ce n’est pas vendre à Avignon, ni à Gordes. Entre le charme des quais de la Sorgue, l’attractivité internationale des week-ends d’antiquaires et la demande des familles pour les villages alentour, chaque micro-marché a ses codes.</p>
          <p>C’est pourquoi chaque estimation s’appuie sur les ventes réelles du secteur, l’état du bien, son exposition et son potentiel — pas sur une moyenne départementale. Vous recevez une première lecture <strong>sous 48 heures</strong>, offerte et sans engagement.</p>
        </article>
        <aside className="agency-number-card" data-testid="expertise-numbers-card">
          <span>Notre terrain de jeu</span>
          <strong>30 km<small> autour de L’Isle-sur-la-Sorgue</small></strong>
          <div><p>Communes suivies</p><b>82</b><span>du Luberon au Ventoux</span></div>
          <div><p>Première estimation</p><b>48 h</b><span>offerte, sans engagement</span></div>
          <em>Honoraires fixes dès 4 900 €, connus dès le premier rendez-vous.</em>
        </aside>
      </section>

      <section className="agency-mission">
        <div className="container agency-mission-layout">
          <div>
            <p className="eyebrow">Et maintenant ?</p>
            <h2>Parlons de votre adresse<br /><span>autour d’un café.</span></h2>
          </div>
          <div>
            <p>Un projet de vente, une succession à préparer, ou simplement l’envie de connaître la valeur de votre bien ? Échangeons sans engagement : vous repartez avec une vision claire, quoi que vous décidiez ensuite.</p>
            <Link to="/estimation" className="primary-button" data-testid="expertise-estimate-link">Estimer mon bien <ArrowUpRight size={17} /></Link>
          </div>
        </div>
      </section>

      <section className="agency-quote container" data-testid="expertise-founder-quote">
        <Quote size={34} />
        <blockquote>Une relation durable commence toujours par l’honnêteté. C’est vrai en amitié, et c’est vrai en immobilier.</blockquote>
        <p>— Mehdi, fondateur de Pimp My Place</p>
      </section>
      <SiteFooter />
    </main>
  );
}
